import React, { Dispatch, SetStateAction } from "react";
import Navigator from '../components/Navigation';
import { ArticleTextSection } from "../articleDetailPage/ArticleTextSection"
import { ProtectedArticleGroup } from "../articleDetailPage/ProtectedArticleGroup";
import { ArticleTitle } from "../articleDetailPage/ArticleTitle";
import { hashPassword, hashPasswordsFromEnv } from "../utils/passwordUtils";
import ArticleImageLayout from "../articleDetailPage/ArticleImageLayout";
import '../style.css';
import { Wavedivider } from "../components/Wavedivider";
import { CalloutLink } from "../components/CalloutLink";
import { useMetaTags } from '../utils/useMetaTags';
import ProtectedPage from "../components/ProtectedPage";
import { QuoteBlock } from "../components/QuoteBlock";
import ProtectedSection from "../components/ProtectedSection";
import NextItem from "../components/NextItem";
import BackButton from "../components/BackButton";
import essay2608Thumbnail from "../image/articles/essay260801.webp";
import image1 from "../image/articles/essay260901.webp";
import image2 from "../image/articles/essay260902.webp";
import image3 from "../image/articles/essay260903.webp";
import image4 from "../image/articles/essay260904.webp";
import image5 from "../image/articles/essay260905.webp";
import image6 from "../image/articles/essay260906.webp";
import image7 from "../image/articles/essay260907.webp";
import image8 from "../image/articles/essay260908.webp";
import image9 from "../image/articles/essay260909.webp";
import image10 from "../image/articles/essay260910.webp";
import image11 from "../image/articles/essay260911.webp";
import image12 from "../image/articles/essay260912.webp";


function Essay2609(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
    const images1 = [image2, image3, image4, ];
    const images2 = [image5, image6, image7];
    const images3 = [image8, ];
    const images4 = [image9, image10, image11, ];
    
      
      const hashedPasswords = hashPasswordsFromEnv(
        process.env.REACT_APP_ESSAY2606_PASSWORDS
      );
      const sectionLockHashes = hashPasswordsFromEnv(
        process.env.REACT_APP_ESSAY2606_SECTION_PASSWORDS
      );
      useMetaTags({
        title: '26.08. 회고 - Lynkim',
        description: '첫 프로젝트 런칭',
        image: '/ogimage.png',
      });
      
      return (
        <>
        {/* <ProtectedPage password={hashedPasswords} description="이 페이지의 비밀번호는 개인번호로 설정되어 있어요"> */}
        <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
        <div className='fadeIn '>
            <ArticleTitle
                title={'26.09. 회고'}
                titleEn={'26.09. Review'}
                description={<div>버거움 내려놓기</div>}
                descriptionEn={<div></div>}
                category={'essay'}
                date={'2026.10.08.'}
                thumbnail={image1}

            />
        </div>
        <Wavedivider/>
        <div className='articleLayout'>
           <ArticleTextSection
                title = '버겁다는 감정'
                titleEn = 'Snippets'
                marginBottom={true}
                description={<div>
                  요즘은 회고글을 쓰는 것조차 버겁다고 느낄 만큼 마음의 여유가 없는 날들이 이어지고 있다.
                  <br/>
                  일에 대해 생각하거나 앞으로 해야 할 일들을 떠올리기만 해도 숨이 턱 막혀온다. 사정이 이렇다 보니 삶에서 정말 중요한 가치들을 못 본 체 잊고 살아가게 된다. 주변 사람들에게 따뜻한 말 한마디 건네는 일, 내 곁의 사람들에게 고마움을 표현하고 챙기는 일조차 제대로 하지 못하고 있다.
                  <br/>
                  나 하나 추스르고 일으켜 세우는 것마저 왜 이리 힘들고 고통스러운 걸까. 지난 한 달을 돌아보며, 어떻게 해야 이 버거움에서 벗어날 수 있을지 고민해 보았다.
                     </div>}
                   />
      
                <ArticleTextSection
                marginTop={true}
                marginBottom={true}
                title = '지금에 집중하지 못하는 삶'
                subTitle={'여의도 불꽃축제'}
                description={<div>
                  9월은 여의도 불꽃축제가 열리는 달이다. 매년 멀리서나마 어떻게든 구경하곤 했지만, 한 번도 더 가까이 가거나 끝까지 볼 생각은 하지 못했다. '가까이서 본다고 감동이 그리 다를까' 하는 마음 때문이었다.
<br/>
그러다 오늘 우연히 여의도 백화점에서 쇼핑을 하다 불꽃축제 현장과 가까워지게 되었다. 밖으로 나오니 축제가 한창인지 화약 냄새가 진동하고 펑펑 터지는 소리가 들렸다. 사람이 워낙 많아 도저히 볼 수 없을 거라 지레 포기하려 했지만, 용기를 내 조금 더 걸어가 보니 생각보다 불꽃이 잘 보였다.
<br/>
그 작은 불꽃마저 너무나 아름다워 '여기서 조금만 보다 돌아갈까' 싶었지만, 마음을 내어 여의도공원까지 가보았다. 그곳에서 본 불꽃축제는 멀찍이서 작게 바라보던 것과는 차원이 다른 감동을 주었다. 생각했던 것보다 훨씬 아름답고 웅장했다. 도중에 돌아갈까 했던 마음도 감동에 파묻혀 사라졌고, 결국 축제가 완전히 끝날 때까지 자리를 떠나지 못했다. 집으로 돌아가는 길은 인파로 붐벼 고되었지만, 그 고생마저 마냥 신나고 즐거웠다.
<br/>
평소의 나였다면 '이 정도 즐겼으면 됐지' 하고 가까이 갈 생각조차 하지 않은 채 이미 집으로 향했을 것이다. 나의 모든 여행이 그랬다. 사람들이 많이 찾는 명소는 굳이 찾아가지 않았다. '가봤자 별거 있겠어?' 하는 생각으로 쉽게 포기해 버리곤 했다.
<br/>
그렇게 대충 느끼고 넘어가다 보니, 역설적이게도 더 다른 여행을 갈망하게 된 것 같다. 나를 온전히 내던져야만 하는 상황이 주어져야 비로소 현재를 음미하려 애쓴다. 그렇지 않으면 약간의 힘듦과 귀찮음에도 쉽게 포기해 버린다. 머릿속은 온통 다음 계획으로 가득 차 정작 '지금 이 순간'에는 집중하지 못한다. 불꽃놀이가 끝난 뒤 집에 돌아갈 걱정, 내일 출근해서 일할 걱정 같은 계획들에 매여 현재를 온전히 누리지 못했던 것이다.
<br/>
그래서 늘 만족하지 못했던 게 아닐까. 산책하며 새로운 공간을 즐길 때 그 순간에 푹 빠져 다른 생각을 하지 않을 수 있다면, 여행에 집착하거나 현실의 버거움을 조금은 내려놓을 수 있지 않을까.  </div>}
                   />
                      <ArticleImageLayout 
                 images={images1}
                />
                   <ArticleTextSection
                marginTop={true}
                marginBottom={true}
                subTitle={'하코네 여행'}
                description={<div>
                  어머니와 함께 떠난 하코네 여행은 생각보다 인상적이고 좋았다. 하지만 어머니를 모시고 가야 한다는 생각에 길을 잃거나 시간이 지체될까 봐 은연중에 스트레스를 받았다. 혹시나 잘못될까 조마조마한 순간이 많아 여유를 누리지는 못했다.
<br/>
한국에 두고 온 일에 자꾸 조바심이 나서 결국 노트북을 켤 수밖에 없었다. 휴식을 취하러 가서 제대로 쉬지 못한 셈이다. 함께 여행을 와서 노트북만 쳐다보고 있는 내 모습을 보며 어머니도 마음이 편치 않으셨을지도 모른다. '다음에 히로시마에 가면 그때 쉬면 되지' 하는 마음으로 끝내 일손을 놓지 못했다.
<br/>
돈에 대한 쪼들림도 한몫했다. 어머니에게 이것저것 해드리며 돈을 쓸 때조차 '이건 몇 시간 더 일하면 메꿀 수 있겠지'라며 일을 떠올렸다. 여러모로 상황이 잘못 돌아가고 있었다.</div>
}/>
              <ArticleImageLayout 
                 images={images4}
                />
               

<ArticleTextSection
                marginTop={true}
                marginBottom={true}
                title={'미래에 대한 막연한 걱정'}
                subTitle={'셀프 가난'}
                description={<div>
                  요즘 들어 유독 '돈이 없다'는 생각을 자주 한다. 돈을 더 많이 벌어야 한다는 생각에 회사 일을 어떻게 더 많이, 오래 할 수 있을까 고민하고, 심지어 적은 돈을 쓸 때조차 스트레스를 받는다.
<br/>
그렇다고 내가 남들에 비해 돈을 많이 쓰거나 버는 것에 비해 낭비하는 편인가 하면, 전혀 그렇지 않다. 주로 어디에 돈을 쓰나 가만히 따져보면 발레 취미 생활, 예쁜 옷 몇 벌, 주말에 카페에서 보내는 시간 정도가 전부다. 외식이나 배달 음식을 자주 시켜 먹는 것도 아니고, 터무니없이 비싼 물건을 사는 것도 아니다. 당장 큰돈이 나갈 일이 있거나 당장 생활이 쪼들리는 상황도 아니다. 오히려 열심히 살며 남들보다 많이 버는 축에 속한다.
<br/>
그런데도 불안한 마음이 드는 건 시간이 계속 흐르고 있기 때문일 것이다. 이제 정말 어린아이가 아니라는 생각이 들면서 남들 다 있는 집이나 차가 없다는 점, 노후 준비가 되어 있지 않다는 막연한 불안감이 밀려왔다. '하루빨리 안정적으로 돈을 벌어야 할 텐데' 하는 생각에 하루하루가 버겁고 그저 월급날만 기다리게 되었다.
<br/>
쓸데없고 막연한 고민 때문에 현재에 충실하지 못하고 빨리 시간만 흐르기를 바라는 건, 내 인생을 너무나 낭비하는 일이다. 돈 때문에 소중한 내 삶을 그저 흘려보내고 싶지 않다.
</div>}/>

<ArticleTextSection
                marginTop={true}
                marginBottom={true}
                subTitle={'완벽한 미래에 대한 버거움'}
                description={<div>
                  완벽한 미래를 만들고 싶다는 욕심 역시 나를 버겁게 한다. 어머니가 원하는 삶을 책임지기 위해 이만큼은 모아야 한다는 압박감, 그리고 삶에서 경험하고 싶은 것들을 이루기 위해 지금 해놓아야 할 것들이 너무 많다.
<br/>
미래의 계획을 떠올리면 당장 보드게임도 만들어야 하고, 건강을 위해 발레도 해야 하고, 일을 더 해서 돈도 모아야 하고, 영어 공부도 해야 한다. 11월에는 투자운용사 자격증도 따기로 했다. 너무나 버겁다.</div>}/>

 <ArticleImageLayout 
                 images={images2}
                />
<ArticleTextSection
                marginTop={true}
                marginBottom={true}
                title={'버거움 내려놓기'}
                description={<div>
                  다 내려놓고 딱 몇 개월만 쉬고 싶다는 생각이 든다.
하지만 당장 몇 개월을 쉰다고 해서 이 마음들이 나아질까? 어쩌면 그것은 지금의 버거움을 다스리는 근본적인 해결책이 아닐지도 모른다. 그렇다면 어떻게 해야 이 버거움을 해소하고 무언가를 내려놓을 수 있을까.
우선 마음의 짐부터 하나씩 내려놓고 싶다.
                  </div>}/>
<ArticleTextSection

                marginBottom={true}
                subTitle={'책임을 내려놓자'}
                description={<div>
                  그다지 중요하지 않은 책임까지 너무 많이 짊어지고 있다. 투자운용사 시험이 너무 부담스럽다면, 시험 결과보다는 '알고 싶었던 내용을 공부하고 시험에 도전해 보았다'는 자체에 의미를 두자. 그보다 훨씬 중요한 삶과 일에 대한 고민에 더 집중해 보자.
               </div>}/>
                <ArticleTextSection
                
                marginBottom={true}
                subTitle={'의무감을 내려놓자'}
                description={<div>
                  매일 운동해야 한다는 부담감도 내려놓자. 발레는 잠시 주 1회로 줄이자. 다행히 이번 달은 휴일도 많으니, 조금 쉬어가는 한 달로 만들어보자.
                  </div>}/>
                  <ArticleTextSection

                marginBottom={true}
                subTitle={'일의 조급함을 내려놓자'}
                description={<div>
                  회사에서 빠르게 나의 역량을 증명해 보여야 한다는 부담이 크다. 하지만 모든 것을 한 번에 잘해내려 하기보다, 내가 할 수 있는 일 하나씩에 집중하자. 차근차근 깊이 있는 결과물을 만들어내며 과도한 부담감을 지우고, 하나씩 문제를 해결해 나가자.
                  </div>}/>
                   <ArticleTextSection

                marginBottom={true}
                subTitle={'돈에 대한 불안감을 내려놓자'}
                description={<div>
                  작은 소비 하나하나에 죄책감을 느끼지 말고, 내가 현재 어디에 돈을 쓰고 있는지 가계부를 쓰며 객관적으로 파악해 보자.
                  </div>}/>
                     <ArticleTextSection

                marginBottom={true}
                subTitle={'하루의 만족도를 올려보자'}
                description={<div>
                  하루하루 조급함에 시달리기보다, 지금 이 순간과 눈앞에 있는 사람들과의 대화에 먼저 온전히 집중하자. 언제부터 다시 '책임을 다하는 모드'로 돌아갈지 기간을 정해두고, 그동안만큼은 책임에서 벗어나 자유로워져 보자.
                  </div>}/>
                <ArticleImageLayout 
                 images={images3}
                />
                
               

        <NextItem to='/Essay2608' thumbnail={essay2608Thumbnail} nextProjectTitle='26.08. 회고'/>

        <BackButton/>
        </div>
        {/* </ProtectedPage> */}
        </>
      )
  }

export default Essay2609;